// @flow
import {
	WebComponent,
} from 'fg-frontend';
import LazyLoad from "vanilla-lazyload";
import lazyloadConfig from "../configureLazyLoad";

// Only initialize it one time for the entire application
if (!document.lazyLoadInstance) {
	document.lazyLoadInstance = new LazyLoad(lazyloadConfig);
}

export default class LazyImage extends WebComponent {
	didMount() {
		document.lazyLoadInstance.update();
	}
}



// WEBPACK FOOTER //
// ./fe/web-3dliving/src/js/components/LazyImage.js